var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageEditN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55742 21.5593H4.75741C3.43193 21.5593 2.35741 20.4848 2.35742 19.1593L2.35751 4.75936C2.35752 3.43388 3.43204 2.35938 4.75751 2.35938H15.5578C16.8833 2.35938 17.9578 3.43389 17.9578 4.75937V9.55937M6.5578 7.15937H13.7578M6.5578 10.7594H13.7578M6.5578 14.3594H10.1578M13.1576 18.2504L18.2488 13.1592L21.6429 16.5533L16.5517 21.6445H13.1576V18.2504Z",
    stroke: "#6F6F6F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageEditN);
export default __webpack_public_path__ + "static/media/ManageEditN.c3a2fd98af10834cd782af90f931ffbf.svg";
export { ForwardRef as ReactComponent };